import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL } from '@sorare/core/src/atoms/typography';
import { HighlightOverlay } from '@sorare/core/src/components/onboarding/HighlightOverlay';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

import { ReplayTitle } from '#src/components/series/ReplayTitle/index.tsx';
import {
  DIAMOND_HEIGHT,
  DIAMOND_WIDTH,
} from '#src/components/series/SeriesBoard/utils.ts';

const horizontalPadding = 24;
const verticalPadding = 16;
const height = DIAMOND_HEIGHT * 3.5 + 2 * verticalPadding;
const width = DIAMOND_WIDTH + 2 * horizontalPadding;

const BorderDiv = styled.div`
  position: absolute;
  border: 1px solid var(--c-rewards-yellow);
  border-radius: var(--unit);
  box-shadow: 0 0 4px 0 var(--c-rewards-yellow);
`;
const TextWrapper = styled(Vertical)`
  position: absolute;
  transform: translateX(-50%) translateY(-100%);
`;

type Props = {
  onClose: () => void;
};
export const SeriesBoardOnboarding = ({ onClose }: Props) => {
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const { sport } = useSportContext();
  const isTabletAndAbove = useIsTabletAndAbove();

  if (lifecycle?.[LIFECYCLE.sawSeriesBoardOnboarding]) {
    return null;
  }

  return (
    <HighlightOverlay
      highlightNames={['SeriesBoardReplayButton']}
      withDelay
      onClose={() => {
        updateLifecycle(LIFECYCLE.sawSeriesBoardOnboarding, true);
        onClose();
      }}
      extras={[
        {
          nextTo: 'SeriesBoardReplayButton',
          render: ({ left, bottom }) => (
            <BorderDiv
              style={{
                left: left - horizontalPadding,
                top: bottom - height + verticalPadding,
                width,
                height,
              }}
            />
          ),
        },
        {
          nextTo: 'SeriesBoardReplayButton',
          render: ({ left, right, bottom }) => (
            <TextWrapper
              center
              className="text-center"
              gap={3}
              style={{
                top: bottom - height - 32,
                left: isTabletAndAbove ? (left + right) / 2 : '50%',
              }}
            >
              <ReplayTitle />
              <BodyL>
                {sport === Sport.FOOTBALL ? (
                  <FormattedMessage defaultMessage="Practice on a past match" />
                ) : (
                  <FormattedMessage defaultMessage="Practice on a past game" />
                )}
              </BodyL>
            </TextWrapper>
          ),
        },
      ]}
    />
  );
};
